import { render } from "./CalendarIcon.vue?vue&type=template&id=19b82302&scoped=true"
import script from "./CalendarIcon.vue?vue&type=script&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&lang=js"

import "./CalendarIcon.vue?vue&type=style&index=0&id=19b82302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b82302"]])

export default __exports__